import translations from '../../translations';
import ErrorTraceId from '../generic/ErrorTraceId';

interface Props {
    error: string | null;
    traceId: string | null;
    retry: () => void;
    environmentsEnabled: boolean;
    isMCR: boolean;
}

const ActivateFailed = ({ error, traceId, retry, environmentsEnabled, isMCR }: Props) => {
    return (
        <>
            {isMCR ? (
                <h3>{translations.FLOW_mcr_acknowledgement_failed}</h3>
            ) : (
                <h3>
                    {environmentsEnabled
                        ? translations.FLOW_build_failed
                        : translations.FLOW_publish_failed}
                </h3>
            )}
            <p>{error}</p>
            <ErrorTraceId traceId={traceId} />
            <button className="btn btn-primary" onClick={retry} type="button">
                {translations.FLOW_retry_button}
            </button>
        </>
    );
};

export default ActivateFailed;
